import logo from './logo.svg';
import './App.scss';
import { useEffect, useState } from "react"
import { useGameStateContext } from './ContextProviders/GameStateContextProvider';
import gameConfig from './gameConfig';
import GameView from './GameView';
import Login from './Components/Login';
import Reel from './Components/ReelTest';

function App() {

  const [view, setView] = useState('Login');
  const [sound, setSound] = useState(true);
  const [devView, setDevView] = useState(false);
  const gameState = useGameStateContext();

  const handleLogin = (name, fullscreen, sound, devView) => {
    //gameState.Connect(name);
    setSound(sound);
    setDevView(devView);
    setView('Game');
    if(fullscreen)
      document.documentElement.requestFullscreen();
  }

  return (
    <>
      {(view === 'Login') && (<Login callbackLogin={handleLogin}/>)}
      {(view === 'Game') && (<GameView sound = {sound} devView={devView}/>)}
    </>
  );
}

export default App;
